package com.evoapps.evoshift.domain.explain

import com.evoapps.evoshift.domain.model.DailyRecord
import com.evoapps.evoshift.domain.model.Spmh
import com.evoapps.evoshift.domain.usecase.finance.DayTrend

/*
 * SH-191: how an SPMH was worked out: the net sales (the target, or the takings) and the hours
 * they are divided by, from the same values the figure on screen comes from ([Spmh]).
 */
object SpmhExplanations {

    /** A day's SPMH of [side] (the plan, or the actual once the takings are in); null where the screen shows "-". */
    fun day(record: DailyRecord, side: Side): PerHour? = when (side) {
        Side.PLAN -> record.spmhPlan?.let {
            PerHour(Figure.SPMH, Side.PLAN, DayExplanations.salesTarget(record), record.costs.plannedHours)
        }
        else -> record.spmhActual?.let {
            val takings = DayExplanations.takings(record) ?: return null
            PerHour(
                Figure.SPMH, Side.ACTUAL, takings, Spmh.actualHours(record.costs.actualHours, record.costs.plannedHours),
                plannedHours = record.costs.actualHours <= 0.0
            )
        }
    }

    /** A month's (or any run of days') SPMH of [side]: their sales ÷ their hours; null without any. */
    fun days(side: Side, days: List<DayTrend>): PerHour? {
        val parts = days.map { it.spmhPart(side) }
        if (Spmh.total(parts) == null) return null
        val counted = parts.filter { it.sales != null }
        val sales = counted.sumOf { it.sales ?: 0.0 }
        return PerHour(
            Figure.SPMH, side,
            MonthExplanations.netSales(side, sales, days),
            counted.sumOf { it.hours },
            plannedHours = side == Side.PLAN
        )
    }
}
